import { createNamedContext } from '@trinity/chat-components/utils';
import type { SurveyVersion } from '@trinity/chat/types/survey';

export const SurveyContext = createNamedContext<SurveyVersion>(null!, 'SurveyContext');